<app-sidebar-wrapper *transloco="let t"
                     [sidebarContent]="sidebarContent"
                     [sidebarTitle]="t('Switch to customer view')"
                     [primaryButtonLabel]="t('Switch')"
                     [secondaryButtonLabel]="t('Cancel')"
                     [isSidebarOpen]="sidebarDisplayStore.switchExternalUserSidebarDisplayed()"
                     (primaryButtonClicked)="onActionButtonClicked()"
                     (sidebarClose)="closeSidebar()"
  data-cy="switch-external-user-sidebar-app-sidebar-wrapper">
  <ng-template #sidebarContent>
    <app-switch-external-user-sidebar-content
      class="w-100"
      [primaryActionClicked]="primaryActionClicked$"/>
  </ng-template>
</app-sidebar-wrapper>
